"use client";

import { ActivityDisplayPreview } from "./previews";

type NutritionDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function NutritionDisplay({
  data,
  participants,
}: NutritionDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="nutrition"
      data={data}
      participants={participants}
    />
  );
}
